export function safelyParseJson(json, { defaultValue } = {}) {
  try {
    return JSON.parse(json) ?? defaultValue;
  } catch {
    return defaultValue ?? json;
  }
}
